import { Result, Button, Flex, Image, Typography, Divider } from "antd";
import { Link } from "react-router-dom";
import BgConstruction from "@/assets/img/bg-constructions.png";
import xconsLogo from "@/assets/img/logo-xcons.webp";

const { Text, Title } = Typography;

export const PageConstruction = () => {
  return (
    <Flex justify="center" align="center" vertical gap={80}>
      <Flex
        align="center"
        vertical
        style={{
          width: 965,
          height: 609,
          backgroundImage: `url(${BgConstruction})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
      >
        <Flex
          justify="center"
          vertical
          style={{
            padding: 16,
            borderRadius: 20,
            border: "1px solid #F0F0F0",
            width: 700,
            marginTop: 100,
          }}
        >
          <Title level={2} style={{ color: "#15744B", margin: "20px 0" }}>
            Pronto podrás acceder a esta funcionalidad
          </Title>
          {/* <Divider />
          <Title level={5}>
            ¿Querés saber cómo va a funcionar? Leelo aquí:{" "}
            <Link
              to="https://service.xcons.com/odoo/knowledge/207"
              target="_blank"
            >
              Documentación
            </Link>
          </Title> */}
        </Flex>
      </Flex>
      <img src={xconsLogo} alt="XCONS logo" style={{ width: 200 }} />
    </Flex>
  );
};
